import { useEffect, useRef, useState } from 'react';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import MenuWarehouseArticleEdit from './MenuWarehouseArticleEdit';
import MenuWarehouseArticleUploadFile from './MenuWarehouseArticleUploadFile';
import { Button, QRCode, Space, Switch, Tooltip } from 'antd';
import MenuWarehouseArticleDetail from './MenuWarehouseArticleDetail';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';

export default function MenuWarehouseArticle(props: any) {

    const ref = useRef<any>(undefined);

    //详情窗口
    const [modalDetailVisible, setModalDetailVisible] = useState(false);

    //详情数据    
    const [detailData, setDetailData] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    /** api服务id */
    const apiId = 'menuWarehouseArticle';

    useEffect(() => {
        //同步获取数据 async - await
        const fetchData = async () => {

        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    const initData = () => {
        const currentData: initDataType = {
            apiId
        }
        ref.current.initData(currentData)
    }

    //生成二维码
    const hanldQrCode = (record: any) => {
        fetchApi.POST(wmService, {
            apiId,
            apiExtend: 'createQrCode',
            apiData: {
                articleId: record.id,
                checkArticleTypeId: record.checkArticleTypeId,
                articleLink: record.articleLink,
                movieId: record.movieId,
                articleTitle: record.articleTitle
            }
        }).then(async (res) => {
            if (res.data === true) {
                antMessage("success", "生成二维码成功");
                await initData();
            }
        })
    }

    const downloadQRCode = (id: string) => {
        const canvas = document.getElementById(id)?.querySelector<HTMLCanvasElement>('canvas');
        if (canvas) {
            const url = canvas.toDataURL();
            const a = document.createElement('a');
            a.download = `${id}.png`;
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };

    //打开详情页面
    const hanldDetail = (record: any) => {
        sendData.id = record.id;
        sendData.articleTitle = record.articleTitle;
        setDetailData(sendData);
        setModalDetailVisible(true);
    }

    //关闭详情，子组件回调函数
    const onCloseModalDetailVisible = (state: boolean) => {
        setModalDetailVisible(false);
    };

    //表头
    const columnsHead = [
        {
            title: '大分类',
            dataIndex: 'menuWarehouseArticleCategory',
            render: (text: any, record: any) => {
                return (
                    <div>{record.menuWarehouseArticleType.menuWarehouseArticleCategory.menuWarehouseArticleCategoryName}</div>
                )
            }
        },
        {
            title: '小分类',
            dataIndex: 'menuWarehouseArticleType',
            render: (text: any, record: any) => {
                return (
                    <div>{text.menuWarehouseArticleTypeName}</div>
                )
            }
        },
        {
            title: '文章标题',
            dataIndex: 'articleTitle',
        },
        {
            title: '查看方式',
            dataIndex: 'checkArticleTypeId',
            render: (text: any, record: any) => {
                if (text === 'link') {
                    return (
                        <Tooltip placement="topLeft" title={record.articleLink} color='blue'>
                            <div>{record.checkArticleTypeName}</div>
                        </Tooltip>
                    )
                }
                if (text === 'tencentMovie') {
                    return (
                        <Tooltip placement="topLeft" title={record.movieId} color='blue'>
                            <div>{record.checkArticleTypeName}</div>
                        </Tooltip>
                    )
                }
                if (text === 'richText') {
                    return (
                        <div>{record.checkArticleTypeName}</div>
                    )
                }
            }
        },
        {
            title: '推广',
            dataIndex: 'isPromo',
            render: (text: any, record: any) => {
                return (
                    <Switch checkedChildren="是" unCheckedChildren="否"
                        checked={text} key={record.id}
                    />
                )
            },
            filters: [
                {
                    text: '是',
                    value: true,
                },
                {
                    text: '否',
                    value: false,
                },
            ],
            onFilter: (value: any, record: any) => record.isPromo === value,
            filterSearch: false,
        },
        {
            title: '推广排序',
            dataIndex: 'promoSortBy',
            sorter: (a: any, b: any) => a.promoSortBy - b.promoSortBy,
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
        {
            title: '详情',
            dataIndex: 'details',
            render: (text: any, record: any) => {
                if (record.checkArticleTypeId === 'richText') {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" onClick={() => hanldDetail(record)}>详情</Button>
                        </Space>
                    )
                }
            }
        },
        sessionStorage.getItem('isAdmin') === 'true' ?
            {
                title: '二维码',
                dataIndex: 'qrCode',
                render: (text: any, record: any) => {
                    if (record.qrCode) {
                        return (
                            <Space size="small">
                                <div id={record.qrCodeId}>
                                    <QRCode color={"#000000"} bgColor={"#ffffff"} size={150} value={`${record.qrCode.qrCodeUrl}qrCodeId=${record.qrCodeId}`} />
                                </div>
                                <Button size={"small"} type="text" onClick={() => downloadQRCode(record.qrCodeId)}>下载</Button>
                            </Space>
                        )
                    }
                    else {
                        return (
                            <Space size="small">
                                <Button size={"small"} type="text" onClick={() => hanldQrCode(record)}>生成二维码</Button>
                            </Space>
                        )
                    }
                }
            } : {},
    ];

    //传关参数
    let sendData = {
        type: 'EDIT',
        id: '',
        articleTitle: ''
    }

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '文章',
        apiId,
        columns,
        showImage: true,
        showUploadFile: true,
        showStates: true,
        pagination: true,
        arrayFilesName: 'menuWarehouseArticleFiles',
        EditComponent: MenuWarehouseArticleEdit,
        UploadFileComponent: MenuWarehouseArticleUploadFile
    };

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>

            {modalDetailVisible
                ? (<MenuWarehouseArticleDetail
                    key={detailData.id}
                    onClose={onCloseModalDetailVisible}
                    data={detailData} />)
                : null}
        </>
    )
}